import { store } from "@/store/configureStore";
import { RoutePropsI } from "@/types/system";
// import { routes } from "./routes";

// 通过用户角色筛选路由
export function filterRoutesByRole(routes: RoutePropsI[]) {
  const { currentRole } = store.getState().user;

  return routes
    .map((route) => {
      if (route.meta) {
        // const { roles: canIn, unRoles: cantIn } = route.meta;
        // 以unRoles 优先
        // 不光是过滤数值，直接会访问不到，因为根据此结果渲染的
        // if (Array.isArray(cantIn) && currentRole && cantIn.includes(currentRole.idStr)) return null;
        // if (Array.isArray(canIn) && currentRole && !canIn.includes(currentRole.idStr)) return null;
      }

      if (!route.children) {
        return route;
      }
      route.children = filterRoutesByRole(route.children);
      return route;
    })
    .filter((i) => i !== null) as RoutePropsI[];
}
